import React, { Component } from 'react';
import { connect } from 'react-redux';
import appConfig from '../../appConfig';

const mapStateToProps = state => ({
  session: state.session,
});

export class ExternalLogin extends Component {
  componentDidMount() {
    const extLogin = this.props.session.get('extLogin');
    window.location = extLogin.toLowerCase().includes('http') ? extLogin : appConfig.cardURL + extLogin;
  }
  render() {
    return (<section>Redirecting...</section>);
  }
}
export default connect(mapStateToProps)(ExternalLogin);



// WEBPACK FOOTER //
// ./src/js/components/ExternalLogin/index.jsx